export const MOODS_LIMIT_TO_SHOW_GRAPH = 7;
